var trimmedEndIndex = require('./_trimmedEndIndex');

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;



//////////////////
// WEBPACK FOOTER
// ./~/victory-selection-container/~/lodash/_baseTrim.js
// module id = ./node_modules/victory-selection-container/node_modules/lodash/_baseTrim.js
// module chunks = 1